













































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import RoleRequest from "@/models/security/roleRequest.model";
import { RowTable } from "@/typings/BRowTable";
import User from "@/models/security/user.model";
import UserService from "@/services/user.service";
import BaseVue from "../../core/BaseVue";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/annoucement/annoucement.Model";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Porposal from "../../models/porposal/porposal.model";
import { ProposalState } from "@/enums/ProposalState";
import PorposalService from "@/services/porposal.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";

@Component({
  components: {
    ResearchCenterBasicInformationComponent
  }
})
export default class PorposalComponent extends GenericBTable<Annoucement> {
  @Prop() public enviada!: boolean;
  @Prop() public devuelta!: boolean;
  @Prop() public all!: boolean;
  @Prop() public estado!: ProposalState;
  annoucementId = null;
  isDeleted: number = 0;
  codes = "";
  code = "";
  proposalService: PorposalService = new PorposalService();
  creado: ProposalState = ProposalState.Creado;
  proposals = [];
  razonUltimoMovimiento: string = "";

  created() {
    this.tableConfig.controller = `Porposal/GetByEstado/${this.estado}`;
    this.formatColumns();
  }

  @Watch("annoucementId")
  getByAnnoucement() {
    this.tableConfig.whereParams = `annoucementId eq  ${this.annoucementId}`;
    this.tableConfig.reload();
  }

  @Watch("code")
  getByCode() {
    this.tableConfig.whereParams = `contains(Code, '${this.code}')`;
    this.tableConfig.reload();
  }

  @Watch("isDeleted")
  onIsDeleted() {
    this.tableConfig.reload();
  }

  searchByCode(event: any) {
    if (event.keyCode === 13) {
      this.code = this.codes.trim();
    }
  }

  async deleteProposal (proposal) {
    let self = this
    const text = await this.$prompt("Escriba el nombre de la propuesta que desea eliminar", "", "", "info")
    const exist = await this.proposalService.validateIfExistProposalByName(text)
    if (exist) {
      const confirm = await this.$confirm(text, `Estas seguro que deseas eliminar la propuesta? `, `warning`)
      if (confirm) {
        this.proposalService.deleteProposalById(proposal.id).then(response => {
            this.operationSuccess()
            this.tableConfig.reload()
          }
        )
      }
    }
    else 
      return this.$alert(text, "No existe ninguna propuesta con el nombre", `error`)
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.proposal", true);
    let researchCenter = new BTableColumn(
      "researchCenter/Name",
      "table.researchCenter",
      true
    );

    name.customTemplate = true;
    researchCenter.customTemplate = true;
    name.width = "350";
    researchCenter.width = "350";

    if (this.estado === ProposalState.Creado) {
      let startDate = new BTableColumn("startDate", "table.startDate", true);
      let endDate = new BTableColumn("endDate", "table.endDate", true);
      startDate.type = BTableColumnType.DateTime;
      endDate.type = BTableColumnType.DateTime;
      this.tableConfig.insertColumns(name, researchCenter, startDate, endDate);
    } else if (
      this.estado === ProposalState.DevueltoCI ||
      this.estado === ProposalState.RechazadoCI
    ) {
      let sendDateToIES = new BTableColumn(
        "sendDateToIES",
        "table.sendDate",
        true
      );
      sendDateToIES.type = BTableColumnType.DateTime;
      //let motivo = new BTableColumn("motivo", "table.motivo", true);
      //motivo.customTemplate = true;
      this.tableConfig.insertColumns(
        name,
        researchCenter,
        //motivo,
        sendDateToIES
      );
    } else {
      let sendDateToIES = new BTableColumn(
        "sendDateToIES",
        "table.sendDate",
        true
      );
      sendDateToIES.type = BTableColumnType.DateTime;
      this.tableConfig.insertColumns(name, researchCenter, sendDateToIES);
    }

    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
  }
  public verOpciones(row: Porposal) {
    this.$router.push(`/convocatoria/propuesta/${row.id}`);
  }

  showRazonUltimoMovimiento(movimientos: any[]) {
    return movimientos[movimientos.length - 1].razon;
  }
}
